import React, { Component } from 'react';
import '../assets/custom.css';
import '../assets/teachers.css';

import { withRouter } from 'react-router-dom';

import logo_picturenaming from '../assets/images/app-picturenaming.png';
import logo_kidspeak from '../assets/images/logo_kidspeak.png';
import logo_wordmark from '../assets/images/logo_wordmark.png';
import logo_slashtest from '../assets/images/logo_slashtest.png';
import logo_wordsignsay from '../assets/images/app-wordsignsay.png';
import logo_kidsign from '../assets/images/app-kidsignsay.png';
import logo_copyright from '../assets/images/app-copyright.png';
import logo_maze from '../assets/images/logo_maze.png';

import HeaderComponent from '../Shared/Header';
import REST from '../Shared/REST';
import FooterComponent from "../Shared/Footer";


let addClassInstruction = null;
let addStudentInstruction = null;

class ContentComponent extends Component {
    constructor(props) {
        super(props);
        this.handleKidSpeak = this.handleKidSpeak.bind(this);
        this.handleMaze = this.handleMaze.bind(this);
    }

    componentDidMount() {

    }

    handleMaze() {
        this.props.history.push("/content/maze");
    }

    handleKidSpeak() {
        this.props.history.push("/content/kidspeak");
    }

    handleLogout = () => {
        REST.logout().then((response) => {
            if(localStorage.getItem('addClass') === 'hide'){
                addClassInstruction = localStorage.getItem('addClass');
            }
            if(localStorage.getItem('addStudent') === 'hide'){
                addStudentInstruction = localStorage.getItem('addStudent');
            }
            localStorage.removeItem('token');
            if(addClassInstruction !== null){
                localStorage.setItem('addClass',addClassInstruction);
            }
            if(addStudentInstruction !== null){
                localStorage.setItem('addStudent',addStudentInstruction);
            }
            this.props.history.push("/login");
        }, (error) => {
            localStorage.removeItem('token');
            localStorage.clear();
            this.props.history.push("/login");
        });
    }

    render() {
        return (
            <div>
                <HeaderComponent contentManagement={true}  logout={this.handleLogout} />
                <div className="section bgGrey">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h2 className="tc">Content Management</h2>
                                {/*<p className="tc">(Click on each app icon to start a new task)</p>*/}
                                <ul className="nav nav-pills pill-sm">
                                        <li style={{margin:10}}>
                                                <a data-toggle="pill"
                                                   onClick={this.handlePictureNaming}
                                                   style={{cursor: "default"}}
                                                >
                                                    <img src={logo_picturenaming} className="ico-l" alt="Picture Naming"
                                                         style={{height:75,filter: "grayscale(100%)", opacity: "0.5"}}
                                                         border="0"/>
                                                </a>
                                        </li>
                                        <li style={{margin:10}}>
                                                <a data-toggle="pill"
                                                   onClick={this.handleWordSignSay}
                                                   style={{cursor: "default"}}
                                                >
                                                    <img src={logo_wordsignsay} className="ico-l" alt="Word Sign/Say"
                                                         style={{
                                                             height: 75,
                                                             filter: "grayscale(100%)",
                                                             opacity: "0.5"
                                                         }}
                                                         border="0"/>
                                                </a>
                                        </li>
                                        <li style={{margin:10}}>
                                                <a data-toggle="pill"
                                                   onClick={this.handleCopyRight}
                                                   style={{cursor: "default"}}
                                                >
                                                    <img src={logo_copyright} className="ico-l" alt="CopyRight" border="0"
                                                         style={{
                                                             height: 75,
                                                             filter: "grayscale(100%)",
                                                             opacity: "0.5"
                                                         }}
                                                    />
                                                </a>
                                        </li>
                                        <li style={{margin:10}}>
                                                <a data-toggle="pill"
                                                   onClick={this.handleSlashTest}
                                                   style={{cursor: "default"}}
                                                >
                                                    <img src={logo_slashtest} className="ico-l" alt="Slashtest" border="0"
                                                         style={{
                                                             height: 75,
                                                             filter: "grayscale(100%)",
                                                             opacity: "0.5"
                                                         }}
                                                    />
                                                </a>
                                        </li>
                                        <li style={{margin:10}}>
                                                <a data-toggle="pill"
                                                   onClick={this.handleKidSpeak}
                                                   style={{cursor: "pointer"}}
                                                >
                                                    <img src={logo_kidspeak} className="ico-l" alt="Kid Speak" border="0"
                                                         style={{
                                                             height: 75,
                                                             filter: "none" ,
                                                             opacity: "1"
                                                         }}
                                                    />
                                                </a>
                                        </li>
                                        <li style={{margin:10}}>
                                                <a data-toggle="pill"
                                                   onClick={this.handleMaze}
                                                   style={{cursor: "pointer"}}
                                                >
                                                    <img src={logo_maze} className="ico-l" alt="Maze" border="0"
                                                         style={{
                                                             height: 75,
                                                             filter: "none",
                                                             opacity: "1"
                                                         }}
                                                    />
                                                </a>
                                        </li>
                                        <li style={{margin:10}}>
                                                <a data-toggle="pill"
                                                   onClick={this.handleKidSign}
                                                   style={{cursor: "default"}}
                                                >
                                                    <img src={logo_kidsign} className="ico-l" alt="KidSign" border="0"
                                                         style={{height:75,
                                                             filter: "grayscale(100%)",
                                                             opacity: "0.5"
                                                         }} />
                                                </a>
                                        </li>
                                        <li style={{margin:10}}>
                                            <a data-toggle="pill"
                                               onClick={this.handleWordMark}
                                               style={{cursor: "default"}}
                                            >
                                                <img src={logo_wordmark} className="ico-l" alt="Word Mark" border="0"
                                                     style={{height:75,
                                                         filter: "grayscale(100%)",
                                                         opacity: "0.5"
                                                     }}
                                                />
                                            </a>
                                        </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <FooterComponent/>
            </div>
        );
    }
}

export default withRouter(ContentComponent);




// WEBPACK FOOTER //
// ./src/ContentComponent/Content.js